import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    container: {
        height:"100%",
        width:"100%",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        margin: theme.spacing(4)
    },
    message: {
        marginRight: theme.spacing(2)
    }
}))